/**
 * Consent banner logic -- v58 Fundament.
 * doku/prototyp-v58/UEBERGABE.md: "Consent-Banner mit 'Nur notwendige' und Aufruf aus der
 * Fußzeile." Uses Shopify's native Customer Privacy API (window.Shopify.customerPrivacy) --
 * no consent app, no third-party cookie library. Markup: snippets/consent-banner.liquid.
 *
 * Fails closed: if Shopify.loadFeatures ever errors or the API never becomes available, the
 * banner (which starts [hidden] in markup) simply never shows and nothing throws -- it does not
 * get stuck open and does not block the page.
 */
(function () {
  'use strict';

  var banner = document.getElementById('ConsentBanner');
  if (!banner) return;

  var statusEl = document.getElementById('ConsentBannerStatus');
  var acceptBtn = banner.querySelector('[data-consent-accept]');
  var necessaryBtn = banner.querySelector('[data-consent-necessary]');
  var lastFocused = null;

  function announce(key) {
    if (!statusEl || !window.themeStrings || !window.themeStrings.consent) return;
    var text = window.themeStrings.consent[key];
    if (text) statusEl.textContent = text;
  }

  function show() {
    lastFocused = document.activeElement;
    banner.hidden = false;
    if (necessaryBtn) necessaryBtn.focus();
  }

  function hide() {
    banner.hidden = true;
    if (lastFocused && typeof lastFocused.focus === 'function') {
      lastFocused.focus();
    }
  }

  // Footer trigger + any future caller: event delegation, so footer.liquid (or anywhere else)
  // only needs `data-consent-open` on a button/link, no JS of its own.
  document.addEventListener('click', function (event) {
    if (event.target.closest && event.target.closest('[data-consent-open]')) {
      event.preventDefault();
      show();
    }
  });

  window.CryonosConsent = window.CryonosConsent || {};
  window.CryonosConsent.open = show;

  // Trap Escape/focus loosely: Escape re-closes only if a choice was already recorded, so the
  // banner can't be dismissed without a decision on first visit (fails toward "no tracking", the
  // safer default, rather than toward "silently dismissed").
  banner.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    if (window.Shopify && window.Shopify.customerPrivacy) {
      var consent = window.Shopify.customerPrivacy.currentVisitorConsent();
      if (consent && consent.marketing !== 'no_interaction') hide();
    }
  });

  // ---- Entscheidung merken (08.10.2026, AUFTRAG 2026-10-08-14)
  // Ursache des erneuten Erscheinens: Nach dem Abschalten des Shopify-Banners im Admin liefert
  // customerPrivacy.shouldShowBanner() immer "true", auch nach setTrackingConsent (die Wahl steht danach nur im Speicher
  // der Seite, currentVisitorConsent() ist beim nächsten Seitenaufruf wieder leer). Deshalb gilt jetzt:
  // 1. entschieden = currentVisitorConsent() hat einen Wert ("yes"/"no") ODER das Erstanbieter-Cookie unten ist gesetzt.
  // 2. Wahl wird an die Shopify Customer Privacy API gemeldet (setTrackingConsent) UND als Cookie gemerkt (12 Monate).
  // 3. Kennt die API die Wahl nicht mehr, das Cookie aber doch, wird sie der API stillschweigend erneut gemeldet.
  var COOKIE = 'cryonos_consent';
  var ALL = { marketing: true, analytics: true, preferences: true, sale_of_data: true };
  var NONE = { marketing: false, analytics: false, preferences: false, sale_of_data: false };

  function readCookie() {
    var m = document.cookie.match(new RegExp('(?:^|; )' + COOKIE + '=([^;]*)'));
    return m ? decodeURIComponent(m[1]) : '';
  }
  function writeCookie(v) {
    try {
      document.cookie = COOKIE + '=' + encodeURIComponent(v) + '; max-age=31536000; path=/; SameSite=Lax' +
        (location.protocol === 'https:' ? '; Secure' : '');
    } catch (e) { /* ohne Cookie weiter */ }
  }
  function apiDecided(api) {
    try {
      var c = api.currentVisitorConsent();
      return !!c && [c.marketing, c.analytics, c.preferences].some(function (x) { return x === 'yes' || x === 'no'; });
    } catch (e) { return false; }
  }

  function choose(kind, api) {
    writeCookie(kind);
    var done = function () { announce(kind === 'all' ? 'saved_all' : 'saved_necessary'); hide(); };
    if (api && typeof api.setTrackingConsent === 'function') {
      var finished = false;
      var once = function () { if (finished) return; finished = true; done(); };
      try { api.setTrackingConsent(kind === 'all' ? ALL : NONE, once); } catch (e) { once(); }
      setTimeout(once, 1500); // Rückruf bleibt aus: Banner trotzdem schließen, Cookie ist gesetzt
    } else {
      done();
    }
  }

  function wire(api) {
    if (acceptBtn) acceptBtn.addEventListener('click', function () { choose('all', api); });
    if (necessaryBtn) necessaryBtn.addEventListener('click', function () { choose('necessary', api); });
  }

  var hasApi = window.Shopify && typeof window.Shopify.loadFeatures === 'function';
  if (!hasApi) {
    // Rückfall ohne API: nur das eigene Cookie.
    wire(null);
    if (!readCookie()) show();
    return;
  }

  window.Shopify.loadFeatures(
    [{ name: 'consent-tracking-api', version: '0.1' }],
    function (error) {
      var api = !error && window.Shopify.customerPrivacy ? window.Shopify.customerPrivacy : null;
      wire(api);
      var stored = readCookie();
      if (api && apiDecided(api)) {
        if (!stored) { var cc = api.currentVisitorConsent(); writeCookie(cc && cc.marketing === 'yes' ? 'all' : 'necessary'); } // Wahl nur in der API: auch als Cookie merken
        return;
      }
      if (stored) {
        if (api) { try { api.setTrackingConsent(stored === 'all' ? ALL : NONE, function () {}); } catch (e) { /* stumm */ } }
        return;
      }
      if (!api) { show(); return; }
      try { if (api.shouldShowBanner()) show(); } catch (e) { show(); }
      document.addEventListener('visitorConsentCollected', function () { if (apiDecided(api)) hide(); });
    }
  );
})();
